module.exports = __webpack_public_path__ + "static/media/background.f1ff44a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/new-haven/background.jpg
// module id = 868
// module chunks = 27